import { defineMessages } from 'react-intl';

export const welcomeMessages = defineMessages({
  TITLE: {
    defaultMessage: 'Bienvenue dans votre Parcours découverte !',
  },

  DESCRIPTION: {
    defaultMessage:
      'Vos <b>{duration} premiers jours</b> vous permettent de découvrir une partie de votre contenu pédagogique et de vous familiariser avec la plateforme.',
  },
} as const);

export const walletMessages = defineMessages({
  TITLE: {
    defaultMessage: 'Vous venez de recevoir {amount, plural, one {# crédit} other {# crédits}} !',
  },

  DESCRIPTION: {
    defaultMessage:
      'Ils vous permettront de débloquer <b>les contenus de votre choix</b> durant cette période.',
  },
} as const);
